document.addEventListener('DOMContentLoaded', () => {
  const faqQuestions = document.querySelectorAll('.tp-faq__question');

  faqQuestions.forEach((question, i) => {
    // aria-controls pose aussi sur les FAQ rendues sans id (FAQ produit)
    const answer = question.nextElementSibling;
    if (!question.hasAttribute('aria-controls') && answer && answer.classList.contains('tp-faq__answer')) {
      if (!answer.id) answer.id = 'tpFaqAnswer-' + i;
      question.setAttribute('aria-controls', answer.id);
    }
    question.addEventListener('click', () => {
      const item = question.closest('.tp-faq__item');
      const list = question.closest('.tp-faq__list');
      const isOpen = item.classList.contains('is-open');

      list.querySelectorAll('.tp-faq__item.is-open').forEach((openItem) => {
        openItem.classList.remove('is-open');
        openItem.querySelector('.tp-faq__question').setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('is-open');
        question.setAttribute('aria-expanded', 'true');
      }
    });
  });
});